import { SimpleGrid } from "@mantine/core";

import { EMPTY_VALUE } from "@/billing/constants/empty-value";

import PracticeBillingSummaryCard from "../PracticeBillingSummaryCard";

import { MISSING_SERVICES_SUMMARY_CARDS } from "./constants/missing-services";
import { MissingServicesSummaryCardsProps } from "./types/missing-services";

export default function MissingServicesSummaryCards({ counts }: MissingServicesSummaryCardsProps) {
  return (
    <SimpleGrid spacing="md" cols={{ base: 1, sm: 3 }} data-testid="missing-services-summary">
      {MISSING_SERVICES_SUMMARY_CARDS.map(
        ({ id, title, description, countKey, icon, iconColor }) => (
          <PracticeBillingSummaryCard
            key={id}
            icon={icon}
            title={title}
            iconColor={iconColor}
            description={description}
            testId={`missing-services-summary-${id}`}
            value={counts ? counts[countKey] : EMPTY_VALUE}
          />
        ),
      )}
    </SimpleGrid>
  );
}
